import React from "react";
import styled from "styled-components";

const StyledFrame = styled.iframe`
    height: 100vh;
    width: 100vw;
`;

const CANCELLATION_POLICY_PAGE_URL = "https://lifeat-docs.super.site/cancellation-policy";

function CancellationPolicyPage() {
    return <StyledFrame src={CANCELLATION_POLICY_PAGE_URL} />;
}

export default CancellationPolicyPage;
